import { SignIn } from "@clerk/clerk-react";
import { useSearchParams } from "react-router-dom";
import { clerkEnabled } from "@/services/clerk";
import { REDIRECT_PARAM, safeRedirect } from "@/lib/redirects";
import { ClerkNotConfigured } from "@/components/ClerkNotConfigured";

export default function SignInPage() {
  // Read before the early return: hooks cannot be called conditionally.
  const [params] = useSearchParams();
  // Clerk takes a fixed URL, and where somebody belongs depends on whether
  // they are a member yet — which is not known until `me` answers. So it goes
  // to /after-sign-in, carrying the destination, and that route decides.
  const asked = params.get(REDIRECT_PARAM);
  const back =
    "/after-sign-in" +
    (asked ? `?${REDIRECT_PARAM}=${encodeURIComponent(safeRedirect(asked))}` : "");
  if (!clerkEnabled) return <ClerkNotConfigured />;
  return (
    <div className="flex min-h-screen flex-col items-center justify-center py-12">
      {/* `withSignUp` is Clerk's combined flow: an address it does not know
          becomes an account here rather than at a second URL. There is no
          /sign-up route — one door, and the site decides on the other side of
          it what that person is (see AfterSignInPage). */}
      {/* `withSignUp` stays: an address Clerk has never seen becomes an
          account here rather than being turned away, which is how the 447
          imported members arrive from their invitations. Somebody who pressed
          Apply is sent to /sign-up instead, where the card is headed by what
          they are actually doing. */}
      <SignIn
        routing="path"
        path="/sign-in"
        withSignUp
        signUpUrl="/sign-up"
        fallbackRedirectUrl={back}
      />
    </div>
  );
}
